import general from './general';
import account from './account';

const routes = [...general, ...account];

export default routes;
